import React from 'react';

import { SubHeading, MenuItem } from '../../components';
import { data, images } from '../../constants';
import './Price.css';

const Price = () => (
  <div className="app__price flex__center section__padding" id="menu">
    <div className="app__price-title">
      <SubHeading title="Paket yang Cocok untuk Anda" />
      <h1 className="headtext__cormorant">Paket & Harga</h1>
    </div>

    <div className="app__price-menu">
      <div className="app__price-menu_regular  flex__center">
        <p className="app__price-menu_heading">Regular</p>
        <div className="app__price_menu_items">
          {data.regulars.map((regular, index) => (
            <MenuItem key={regular.title + index} title={regular.title} price={regular.price} tags={regular.tags} />
          ))}
        </div>
      </div>

      <div className="app__price-menu_img">
        <img src={images.menu} alt="menu__img" />
      </div>

      <div className="app__price-menu_premium  flex__center">
        <p className="app__price-menu_heading">Premium</p>
        <div className="app__price_menu_items">
          {data.premiums.map((premium, index) => (
            <MenuItem key={premium.title + index} title={premium.title} price={premium.price} tags={premium.tags} />
          ))}
        </div>
      </div>
    </div>

    <div style={{ marginTop: 15 }}>
      <button type="button" className="custom__button">View More</button>
    </div>
  </div>
);

export default Price;